"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferenceModels = void 0;
const reference_1 = __importDefault(require("./reference"));
exports.ReferenceModels = [
    reference_1.default,
];
